module.exports = __webpack_public_path__ + "img/engine_four.16b1062a.png";